import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/navigation";

const CitySwiper = ({ images }: any) => {
  return (
    <div className="site-swiper">
      <Swiper
        autoplay={{
          delay: 5000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Navigation]}
        navigation={{
          prevEl: ".custom-prev",
          nextEl: ".custom-next",
          disabledClass: "custom-btn-disabled",
        }}
      >
        {images &&
          images.map((image: any, index: number) => (
            <SwiperSlide key={index}>
              {image.url ? (
                <img
                  className="active-image"
                  src={image.image_url}
                  onClick={() => window.open(image.url, "_blank")}
                />
              ) : (
                <img src={image.image_url} />
              )}
            </SwiperSlide>
          ))}
        <div className="btn-wrapper">
          <div className="custom-prev"></div>
          <div className="custom-next"></div>
        </div>
      </Swiper>
    </div>
  );
};
export default CitySwiper;
